import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import {faReply} from "@fortawesome/pro-regular-svg-icons";
import JeffYardiProspectRefreshForm from "./jeffYardiProspectRefreshForm";


const JeffYardiProspectRefreshFormDialogButton = () => {
    const [showDialog, setShowDialog] = React.useState(false);

    return (
        <React.Fragment>
            <Button
                color="primary"
                onClick={handleOpen}
                variant={'outlined'}
                // size={'small'}
            >
                <FontAwesomeIcon
                    icon={faReply}
                    fixedWidth
                />
                &nbsp;Refresh Yardi Prospect
            </Button>

            <Dialog
                open={showDialog}
                onClose={handleClose}
                aria-labelledby="jeff-credit-dialog-title"
                aria-describedby="jeff-credit-description"
            >
                <DialogTitle id="account-dialog-title">Refresh Yardi Prospect</DialogTitle>
                <DialogContent>
                    <JeffYardiProspectRefreshForm doneCallback={handleClose}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );

    function handleOpen() {
        setShowDialog(true);
    }

    function handleClose() {
        setShowDialog(false);
    }
};


export default JeffYardiProspectRefreshFormDialogButton;